import { cn } from '@brew/ui/cn'
import { Skeleton } from '@brew/ui/skeleton'
import type { ReactNode } from 'react'

/**
 * Slack's settings while they load, shaped like the connected form's four
 * sections. One skeleton covers both waits, the chunk (`next/dynamic`) and
 * every query the form reads, so nothing blinks or pops in section by
 * section.
 */
export function SlackFormSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading Slack settings"
      className="flex flex-col gap-8"
      role="status"
    >
      <SkeletonSection titleClassName="w-24">
        <Skeleton className="h-[62px] w-full" />
      </SkeletonSection>
      <SkeletonSection titleClassName="w-44">
        <div className="flex items-start gap-4">
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
          <Skeleton className="h-5 w-9 shrink-0 rounded-full" />
        </div>
      </SkeletonSection>
      <SkeletonSection titleClassName="w-52">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-[62px] w-full" />
      </SkeletonSection>
      <SkeletonSection titleClassName="w-36">
        <Skeleton className="h-4 w-3/4" />
      </SkeletonSection>
    </div>
  )
}

function SkeletonSection({
  titleClassName,
  children,
}: {
  titleClassName: string
  children: ReactNode
}) {
  return (
    <div className="flex flex-col gap-3">
      <Skeleton className={cn('h-6 rounded-sm', titleClassName)} />
      {children}
    </div>
  )
}
